import { render, staticRenderFns } from "./Grade.vue?vue&type=template&id=88119c96&scoped=true&"
import script from "./Grade.vue?vue&type=script&lang=ts&"
export * from "./Grade.vue?vue&type=script&lang=ts&"
import style0 from "./Grade.vue?vue&type=style&index=0&id=88119c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88119c96",
  null
  
)

export default component.exports